const AssignmentPage = () => {
    return (  
        <div className="assignment">
         <h2 style={{marginTop: "30px"}}>Divine Assignment 2023</h2>

         <p>
          <em>Book Reading</em> <br/><br/>
          1.  Love, Submission and Headship in Marriage <br/>
          2.  God's Healing for His Children Through Faith and The Use of Medicine <br/>
          3.  Faith & Patience in Your Situation <br/>
          4.  Raising Up Godly Children for Jesus <br/>
          5.  Making Your Father and Mother Glad by Your Life <br/>
          6.  Record Keeping and Accountability In Ministry <br/>
          7.  Scriptural Ministry of a Holy Woman <br/>
          8.  Scriptural Burial Ceremony Is a Period of Mourning, Not Feasting for Holy Christians <br/><br/>

          Members who cannot read should listen to audio books or Bible 3 times. <br/><br/>

          <em>Bible Reading</em> <br/><br/>
           Leaders - Genesis to Deuteronomy with commentaries. <br/>
           Other Members - Genesis to Deuteronomy no commentaries. <br/><br/>

           <em>Messages</em> <br/><br/>
        
           Watch/Listen to 80 video or audio recorded messages. <br/><br/>

           <em>Prayer and Fasting</em> <br/><br/>

            i. Leaders - 1 hour 30mins daily. <br/> 
            ii. Other Members - 1 hour <br/>
            Fasting should be at least twice in a month. <br/><br/>

            <em>Soul Winning</em> <br/><br/>
            3 converts abiding in Christ.<br/><br/>

         </p>


        </div>
    );
}
 
export default AssignmentPage;